export default __webpack_public_path__ + "static/media/globus-logo.24bc07d9.svg";